import React from "react";
import "../../App.css";

import { BackToIndustryVerticalsButton } from "../layout/BackButton";
import QuickLinksSection from "../products/QuickLinksSection";
import { ITFeatureSection } from "./InformationTechnologyPage";

// Health Detail Page
function HealthPage({ handleNavClick }) {
  return (
    <div className="industry-detail-page health-page">
      <BackToIndustryVerticalsButton handleNavClick={handleNavClick} />

      {/* Header Section */}
      <div className="health-detail-header">
        <div className="section__container">
          <h2 className="section__title">Health</h2>
          <p className="section__intro">
            Advancing public health through geospatial analysis and location-based healthcare solutions.
          </p>
        </div>
      </div>

      {/* About Health Section */}
      <section className="it-about-section">
        <div className="section__container it-about-container">
          <div className="it-about-text">
            <h2>About Health</h2>
            <p>
              Geotech plays a vital role in the healthcare sector by offering advanced medical technologies
              and devices that enhance the world of health through improved diagnostics and efficient
              delivery of care. Our mission is to empower frontline healthcare professionals with
              innovative solutions that drive better patient outcomes and streamline clinical operations.
            </p>
          </div>
          <div className="it-about-image">
          <img src="/health1.png" alt="Advancing Healthcare Through Technology" />
          </div>
        </div>
      </section>

      {/* Section 1: Empowering Healthcare Professionals (Image Left, Text Right) */}
      <ITFeatureSection
        title="Empowering Healthcare Professionals"
        text="Geotech empowers frontline healthcare professionals with innovative solutions that drive better patient outcomes and streamline clinical operations. By combining advanced technologies with user-focused design, we help medical teams deliver faster and safer care."
        imgSrc="/health2.png"
        imgAlt="Empowering Healthcare Professionals"
      />


      {/* Section 2: Research and Seamless Integration (Text Left, Image Right) */}
      <ITFeatureSection
        title="Research and Seamless Integration"
        text="Through continuous research and development, Geotech creates medical technologies that support accurate diagnostics and fit effortlessly into healthcare workflows. Our systems enhance efficiency, reduce manual processes, and promote data-driven decision-making."
        imgSrc="/health3.png"
        imgAlt="Medical Research and Workflow Integration"
        reverse
      />


      {/* Section 3: Precision and Intelligent Systems (Image Left, Text Right) */}
      <ITFeatureSection
        title="Precision and Intelligent Systems"
        text="By merging precision engineering with intelligent automation, Geotech enables healthcare institutions to deliver faster, safer, and more effective treatment. Our smart systems provide AI-powered insights for improved clinical outcomes."
        imgSrc="/health4.png"
        imgAlt="Precision and Intelligent Systems"
      />


      {/* Section 4: Transforming Patient Care (Text Left, Image Right) */}
      <ITFeatureSection
        title="Transforming Patient Care"
        text="At Geotech, we bridge the gap between patients and providers by making healthcare more accessible, affordable, and impactful. Through innovation in medical technology, we are transforming how care is delivered and enabling a healthier future worldwide."
        imgSrc="/health5.png"
        imgAlt="Transforming Patient Care"
        reverse
      />


      {/* Quick Links Section */}
      <QuickLinksSection
        handleNavClick={handleNavClick}
        links={[
          { id: "information-technology", title: "Information Technology", icon: "/bgs/IT_bg.png" },
          { id: "gis-services", title: "GIS and Data Services", icon: "/bgs/IT_bg.png" },
          { id: "environment", title: "Environment", icon: "/bgs/env.png" },
          { id: "agriculture", title: "Agriculture", icon: "/bgs/agriculture.png" },
          { id: "education-research", title: "Education & Research", icon: "/bgs/edu.png" },
        ]}
      />
    </div>
  );
}

export default HealthPage;
